<template>
  <div id="zgh">
    <TopList :navList="navList" @setType="setType"></TopList>
    <Zgh></Zgh>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Zgh from "./components/zgh";
export default {
  name: "index",
  components: {
    TopList,
    Zgh,
  },
  data() {
    return {
      type: 0,
      name: "",
      navList: ["征稿函"],
    };
  },
  methods: {
    setType(e) {
      this.type = e;
      this.name = this.navList[e];
    },
  },
};
</script>

<style lang="scss" scoped>
#zgh {
}
</style>
